export default __webpack_public_path__ + "static/media/carret-up.41a48c11.svg";